import type { ItemDefinition } from '../../shared/game/supply-types.js';

// Core Rules p. 37: 1 use, recovers 1 Wound during a Field Rest, 20 gp. The book gives no stack size, so each kit takes a slot.
export const medicalKit: ItemDefinition = {
  id: 'medical-kit', name: 'Medical Kit', description: 'Bandages, salves and needles. One use.',
  effect: { kind: 'wound-care', wounds: 1 }, cost: 20, stack: 1,
};
